<template>
  <HoverMenu v-if="sortable"
             v-model="menuopen">
    <template v-slot:menu-activator>
      <v-btn :color="isSorted ? 'tertiary' : ''"
             class="px-1"
             :text="menuopen || delayedmenuopen"
             :icon="!menuopen && !delayedmenuopen"
             small>
        <v-icon size="17"
                :class="menuopen ? 'mr-1' : ''"
                v-text="'mdi-sort'" />
        <v-expand-x-transition>
          <div v-if="menuopen"
               v-text="isSorted ? $t('servicesystem.common_objects.commonterms.sorted') : $t('servicesystem.common_objects.commonterms.unsorted')" />
        </v-expand-x-transition>
      </v-btn>
    </template>

    <template v-slot:menu-content>
      <v-card class="pa-2">
        <h4 v-text="$t('servicesystem.common_objects.commonterms.sort_by')"
            class="mb-2 ml-2" />

        <v-btn v-for="field in fieldlist"
               :key="field.key"
               :color="sortColor(field.key)"
               class="mx-2"
               small
               @click="reSort(field.key, field.type)">
          {{$t(field.displayString)}}
          <v-icon size="20"
                  class="ml-2"
                  v-text="sortIcon(field.key)" />
        </v-btn>
      </v-card>
    </template>
  </HoverMenu>
</template>


<script>
import HoverMenu from "@/components/Menus/HoverMenu.vue";

export default {
  name: "SorterMenu",
  model: {
    prop: "outputlist",
    event: "change",
  },
  props: {
    inputlist: Array,
    outputlist: Array,
    fieldlist: Array,
  },
  components: { HoverMenu },

  data: () => ({
    menuopen: false,
    delayedmenuopen: false,
    sortParams: { key: null, desc: false },
    timestamp: null,
    refreshlimit: 100,
  }),

  mounted() {
    //this.sortParams = this.$store.getters["prefrences/Prefrence"]("SortJobList");
  },

  methods: {
    reSort(targetKey, type) {
      if (!this.repeaterBlock()) {
        const { desc, key } = this.sortParams;
        if (key === targetKey) {
          if (desc) {
            //if descending and target; change direction
            this.sortParams = { key: targetKey, desc: false, type: type };
          } else {
            //if asending and target; clear
            this.sortParams = { key: null, desc: false, type: null };
          }
        } else {
          //if not target; set to target descending
          this.sortParams = { key: targetKey, desc: true, type: type };
        }
        //this.$store.dispatch("prefrences/set_prefrence", { key: "SortJobList", value: this.sortParams });
      }
    },

    sortColor(key) {
      if (this.sortParams.key != key) {
        return "";
      } else {
        return this.sortParams.desc ? "primary" : "primary";
      }
    },

    sortIcon(key) {
      if (this.sortParams.key != key) {
        return "mdi-unfold-more-horizontal";
      } else {
        return this.sortParams.desc ? "mdi-chevron-down" : "mdi-chevron-up";
      }
    },

    typedCompare(o1, o2, type) {
      var retval;
      switch (type) {
        case "int":
          retval = o1 - o2;
          break;
        case "string":
          retval = o1.localeCompare(o2);
          break;
        case "datetime":
          retval = this.comparedatetime(o1, o2);
          break;
        default:
          retval = o1 - o2;
      }
      return retval;
    },

    repeaterBlock() {
      if (new Date() - this.timestamp < this.refreshlimit) {
        
        return true;
      } else {
        return false;
      }
    },
  },

  computed: {
    sortable() {
      return this.fieldlist && this.fieldlist.length > 0;
    },

    isSorted() {
      return this.sortParams.key != null && this.fieldlist.filter((e) => e.key === this.sortParams.key).length > 0;
    },

    sortedList() {
      var list = Object.assign([], this.inputlist);
      list = list.sort((job1, job2) => {
        const { desc, key, type } = this.sortParams;
        const { firstval, secondval } = desc
          ? { firstval: job1[key], secondval: job2[key] }
          : { firstval: job2[key], secondval: job1[key] };
        return this.typedCompare(firstval, secondval, type);
      });
      
      return list;
    },
  },

  watch: {
    sortedList: function (newval) {
      if (!this.repeaterBlock()) {
        
        this.timestamp = new Date();
        this.$emit("change", newval);
      }
    },

    menuopen: function (val) {
      setTimeout(() => (this.delayedmenuopen = val), 100);
    },
  },
};
</script>


<style lang="scss" scoped>
</style>